import React from "react";
export function LinkedinColored({
  size = 20
}) {
  return /*#__PURE__*/React.createElement("svg", {
    width: `${size}px`,
    height: `${size}px`,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.75 38.5417C43.75 41.4187 41.4187 43.75 38.5417 43.75H11.4583C8.58229 43.75 6.25 41.4187 6.25 38.5417V11.4583C6.25 8.58125 8.58229 6.25 11.4583 6.25H38.5417C41.4187 6.25 43.75 8.58125 43.75 11.4583V38.5417Z",
    fill: "#0288D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.7917H17.7083V37.5H12.5V19.7917ZM15.0885 17.7083H15.0594C13.5052 17.7083 12.5 16.55 12.5 15.1031C12.5 13.625 13.5365 12.5 15.1187 12.5C16.7031 12.5 17.6792 13.625 17.7083 15.1031C17.7083 16.549 16.7031 17.7083 15.0885 17.7083ZM37.5 37.5H32.2917V28.0219C32.2917 25.7323 31.0156 24.1698 28.9667 24.1698C27.4031 24.1698 26.5573 25.224 26.1469 26.2427C25.9969 26.6073 26.0417 27.6156 26.0417 28.125V37.5H20.8333V19.7917H26.0417V22.5167C26.7927 21.3542 27.9688 19.7917 30.9771 19.7917C34.7042 19.7917 37.499 22.1354 37.499 27.3687L37.5 37.5Z",
    fill: "white"
  }));
}
//# sourceMappingURL=LinkedinColored.js.map